import { fromServerIsoString } from '@se/platform';
import moment, { isMoment, Moment } from 'moment';
import { MomentParams, ToISOStringParams } from './interfaces';

export const parseToMoment = (value: Date | string): Moment | null => {
    const date = typeof value === 'string' ? fromServerIsoString(value) : moment(value);
    if (date.isValid()) return date;
    return null;
};

export const parseToISOString = (value: Date | Moment): string | null => {
    if (value instanceof Date) return value.toJSON();
    if (isMoment(value) && value.isValid()) return value.utc(false).toDate().toJSON();
    return null;
};

export const dateFunctionMap: Record<string, Function> = {
    MOMENT: (params: MomentParams) => parseToMoment(...params),
    TO_ISO_STRING: (params: ToISOStringParams) => parseToISOString(...params),
};
